<template>
  <div class="ex-info">
    <div>
      <template v-if="list && list.items && list.items.length">
        <div class="my-item2">
          <Row :gutter="30">
            <Col span="8" v-for="(item, index) in list.items" :key="'ex-info-' + index">
              <div
                class="my-item2-box"
                v-if="item.exhibitionId !== '00000000-0000-0000-0000-000000000000'"
              >
                <div class="mi-top">
                  <div class="mi-top-left">
                    <img :src="item.exInfo.Logo" v-if="item.exInfo.Logo" class="mi-top-left_logo" />
                    <img src="@assets/img/empty.png" v-else class="mi-top-left_logo" />
                  </div>
                  <div class="mi-top-right">
                    <div class="mi-top-right-info">{{item.exInfo.Name}}</div>
                    <div
                      class="mi-top-right-date"
                    >{{item.exInfo.StartTime | moment("YYYY/MM/DD")}} ~ {{item.exInfo.EndTime | moment("YYYY/MM/DD")}}</div>
                  </div>
                </div>
                <div class="mi-content">
                  <div class="mi-content-info">
                    展品类别：
                    <template
                      v-if="item.categories && item.categories.length"
                    >{{item.categories.join('、')}}</template>
                  </div>
                  <div class="mi-content-info">
                    展位号：
                    <template
                      v-for="(c, index) in item.boothInfo"
                    >{{(index + 1 === item.boothInfo.length) ? `${c.Hall}-${c.Code}` :`${c.Hall}-${c.Code}、`}}</template>
                  </div>
                </div>
                <div class="mi-tool">
                  <!-- <div class="mi-tool-item z-del">
                    <Poptip
                      confirm
                      placement="top-start"
                      title="删除此展会后，与其关联的云展台的数据将被清空，是否继续操作 ?"
                      @on-ok="delItem(item)"
                    >删除</Poptip>
                  </div>-->
                  <!-- <div class="mi-tool-line">|</div> -->
                  <div class="mi-tool-item z-primary" @click="linkToTemplate(item)">编辑</div>
                  <!-- <div class="mi-tool-line">|</div>
                  <div class="mi-tool-item" @click="showShareEdit(item)">分享</div>-->
                </div>
              </div>
              <div class="my-item2-box" v-else>
                <div class="mi-top">
                  <div class="mi-top-left">
                    <img src="@assets/img/empty.png" class="mi-top-left_logo" />
                  </div>
                  <div class="mi-top-right">
                    <div class="mi-top-right-info">未绑定展会</div>
                    <div class="mi-top-right-date">-------</div>
                  </div>
                </div>
                <div class="mi-content">
                  <div class="mi-content-info">展品类别： -----</div>
                  <div class="mi-content-info">展位号： -----</div>
                </div>
                <div class="mi-tool">
                  <!-- <div class="mi-tool-item z-del">
                    <Poptip
                      confirm
                      placement="top-start"
                      title="删除此展会后，与其关联的云展台的数据将被清空，是否继续操作 ?"
                      @on-ok="delItem(item)"
                    >删除</Poptip>
                  </div>-->
                  <!-- <div class="mi-tool-line">|</div> -->
                  <div class="mi-tool-item z-primary" @click="linkToTemplate(item)">编辑</div>
                  <!-- <div class="mi-tool-line">|</div>
                  <div class="mi-tool-item" @click="showShareEdit(item)">分享</div>-->
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div class="my-page" v-if="totalCount > pageSize">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </template>
      <emptyList v-else @change="showAdd()"></emptyList>
    </div>

    <Contact />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import lookShare from "../../components/look-share.vue";

import Contact from "@components/Contact/Contact";
import emptyList from "@components/emptyList/emptyList";

export default {
  name: "exhibition-info-list",
  data() {
    return {
      flag: false,
      add: false,
      edit: false,
      list: null,
      pageSize: 20,
      pageIndex: 1,
      totalCount: 0,
      editInfo: null,
      timer: null
    };
  },
  components: {
    lookShare,
    Contact,
    emptyList
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    }),
    option() {
      return {
        CompId: this.company.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex
      };
    }
  },
  methods: {
    ...mapActions({
      getByCompany: "exhibitionModule/getByCompany",
      delByCompany: "exhibitionModule/delByCompany"
    }),
    async init() {
      let exData = await this.getByCompany(this.option);
      if (exData) {
        this.list = exData;
        this.list.items.map((c, i) => {
          if (c.video) c.video = JSON.parse(c.video);
          if (c.exInfo) c.exInfo = JSON.parse(c.exInfo);
          if (c.categories) c.categories = JSON.parse(c.categories);
          if (c.boothInfo) c.boothInfo = JSON.parse(c.boothInfo);
          if (c.shareInfo) c.shareInfo = JSON.parse(c.shareInfo);
          if (c.banner && c.banner.indexOf("[") !== -1)
            c.banner = JSON.parse(c.banner);
        });
        this.pageSize = exData.pageSize;
        this.pageIndex = exData.pageIndex;
        this.totalCount = exData.totalCount;
      }
    },
    showShareEdit(item) {
      this.add = true;
      this.editInfo = item;
    },
    hideShareEdit(item) {
      this.add = false;
      this.editInfo = null;
    },
    showAdd() {
      this.$router.push("/exhibition/template/choice-new?origin=2&type=add");
    },
    showEdit(item) {
      this.edit = true;
      this.editInfo = item;
    },
    hideEdit() {
      this.edit = false;
      this.editInfo = null;
    },
    async delItem(item) {
      let result = await this.delByCompany(item.joinId);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    changearr(arr) {
      arr.forEach(item => {
        return item.endTime;
      });
    },
    // 分页
    handleChange(page) {
      this.pageIndex = page;
      this.init();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.init();
    },
    linkToTemplate(item) {
      // console.log(item);return
      const msg = this.$Message.loading({
        content: "加载中...",
        duration: 0
      });
      setTimeout(msg, 200);
      const linkUrlArr = [
        "service",
        "brand",
        "franchisee",
        "factory",
        "choice"
      ];
      let num = 4;
      switch (item.tempId) {
        case "00000000-0000-0000-0000-000000000001":
          num = 0;
          break;
        case "00000000-0000-0000-0000-000000000002":
          num = 1;
          break;
        case "00000000-0000-0000-0000-000000000003":
          num = 2;
          break;
        case "00000000-0000-0000-0000-000000000004":
          num = 3;
          break;
      }
      this.$router.push(
        `/exhibition/template/${linkUrlArr[num]}?origin=2&editId=${item.joinId}`
      );
    }
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>

<style scoped lang="scss">
.ex-info {
  &-top {
    width: 100%;
    min-height: 100px;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    padding: 20px 24px 0 36px;
    &-l {
      height: 100%;
      display: flex;
      flex-direction: column;
      .s1 {
        flex: 1;
        font-size: 14px;
        color: #8c8c8c;
      }
      .h1 {
        flex: 1;
        font-size: 18px;
        color: #333;
        font-weight: bold;
      }
      .s2 {
        flex: 1;
        font-size: 14px;
        color: #333;
      }
    }
    &-r {
      &-box {
        width: 150px;
        height: 80px;
        border: 1px dashed #1890ff;
        background-color: #e7f4ff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .I1 {
          font-size: 16px;
          font-weight: bold;
          color: #1890ff;
        }
        .s3 {
          font-size: 14px;
          color: #1890ff;
          margin-left: 9px;
        }
      }
    }
  }
  &-content {
    min-width: 1000px;
    padding: 30px;
    padding-bottom: 50px;
  }
  &-list {
    width: 100%;
    display: inline-block;
    background-color: #fff;
    margin-bottom: 30px;
    &-img {
      width: 100%;
      padding-bottom: 66.666667%;
      position: relative;

      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }
    &-title {
      padding-left: 10px;
      font-size: 14px;
      color: #1a1a1a;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 31px;
      background: #fff;
      height: 66px;
      padding: 10px 10px 7px 12px;
    }
    &-time {
      width: 300px;
      min-height: 27px;
      padding-left: 10px;
      font-size: 14px;
      color: #fe791e;
    }
  }
}
.pro {
  &-tool {
    display: flex;
    height: 48px;
    align-items: center;
    justify-content: space-around;
    background-color: #f7f9fa;

    &-item {
      flex: 1;
      line-height: 48px;
      font-size: 14px;
      color: #808080;
      cursor: pointer;
      text-align: center;
      &:hover {
        color: #1890ff;
      }

      &.z-del {
        &:hover {
          color: #f00;
        }
      }
    }

    &-line {
      background-color: #e8e8e8;
      font-size: 20px;
      width: 1px;
      height: 22px;
    }
  }
}
</style>